import React , {useEffect, useState} from 'react'
import Parse from 'react-html-parser'
// import {useForm} from 'react-hook-form'
import {Grid} from '@mui/material'
import { Link } from 'react-router-dom'
import {NotFound} from '../../../../assets/img'
import {Back , Category , Type} from '../../../../assets/svg'
import FireIcon from '../../../../assets/img/file/fire-icon.png'
// import { signCourse} from '../../../../services'
import './detail.scss'
import { Dojo , Demand } from '../../../../utilities'
import { useLocation,  } from 'react-router-dom/cjs/react-router-dom.min'

function Index() {

    // const {register , handleSubmit , formState : {errors} } = useForm()

    const {search} = useLocation()

    const params = new URLSearchParams(search)

    const [menu , setMenu] = useState(1)

    const [data , setData] = useState(null)

    const [notFound , setNotFound] = useState(0)

    useEffect( () => {
        // console.log(params.get('id'))
        setData( params.get('menu') === '1' ? 
        Dojo.find((items , index) => items.id === Number(params.get('id'))) :
        Demand.find((items , index) => items.id === Number(params.get('id')))
        )
    },[])

    if( data === null || data === undefined) return null

    return (
        <section id='course'>
            {
                notFound === 0 ?                
                <div className='course-detail'>
                    <div className='jumbotron' style={{backgroundImage : `url('${data.link_img}')`}}>
                    </div>

                    <Grid container className='wrapper'>
                        <Grid item md={8} lg={9} className='column-1'>
                            <div className='wrap-head'>
                                <div>
                                    <h3 className='title'>{data.title}</h3>
                                </div>
                                { data.is_hot_topic && 
                                    <div className='hot-topic'>
                                        <img src={FireIcon} alt="" />
                                        <span style={{marginLeft : 10}}>Hot Topics</span> 
                                    </div>
                                }
                            </div>
                            {
                                data.menu === 'Dattabot Dojo Programs' &&
                                <div className='wrap-menu'>
                                    <button onClick={() => setMenu(1)} className={menu === 1 ? 'active' : 'not-active'} >Description</button>
                                    <button onClick={() => setMenu(2)} className={menu === 2 ? 'active' : 'not-active'}>Modul</button>
                                </div>
                            }

                            {
                                menu === 1 ?
                                <>
                                    <p className='body'>{data.description}</p>
                                    
                                    {
                                        data?.description_list && 
                                        (
                                            <ul className='body'>
                                                {data?.description_list?.map( item => (<li>{item}</li>))}
                                            </ul>
                                        )
                                    }
                                </> :
                                <ul className='body'>
                                    {
                                        data.modul.map( item => (<li>{item}</li>))
                                    }
                                </ul>
                            }

                            

                            <Link className='back' to='/courses'>
                                <img src={Back} alt='' />
                            </Link>
                        </Grid>

                        <Grid item md={4} lg={3} className='column-2'>
                            <a className='join' href='mailto:muhammad.gilang@dattabot.io'>
                                Join Our Courses
                            </a>

                            <div className='info-course'>
                                <div className="info">
                                    <div className="category">
                                        <span>
                                            <img src={Category} alt="" />
                                            <span>{data.tipe}</span>
                                        </span>
                                    </div>

                                    <div className="type">
                                        <span>
                                            <img src={Type} alt="" />
                                            <span>{data.program}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className='duration'>
                                <p className='time'>Session: Online And/Or Offline</p>
                                <p className='time'>Participant: {data.minimum_participan} - {data.maximum_participan} Participants</p>
                            
                            </div>
                        </Grid>
                    </Grid>

                    {/* <div className={`modal-background ${open ? 'active' : '' }`}>
                        <div className={`modal-container ${open ? 'active' : '' }`}>
                            <span className='close' onClick={() => {
                                    setOpenDialog(false)
                                    setSuccess(null)
                            }}>&#10006;</span>
                            <h3 className='modal-title'>{ success === null ? "Contact Us" : "Thank You For Joining Course"}</h3>

                            { success === null ?
                            
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className='input-wrapper'>
                                <input 
                                    {...register('name' , { required : "*Please Input Your Name"})} 
                                    className='input' 
                                    placeholder='Your Name*' 
                                />
                                {errors.name && <span className='errors'>{errors.name.message}</span>}
                                </div>

                                <div className='input-wrapper'>
                                <input 
                                    {...register('email' , 
                                        { required : "*Please Input Your E-mail" , pattern : {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                            message: "*Please Enter A Valid E-mail Address",
                                        }})} 
                                    className='input' 
                                    placeholder='Your Email*' 
                                />
                                {errors.email && <span className='errors'>{errors.email.message}</span>}
                                </div>

                                <div className='input-wrapper'>
                                <select value={data.title}
                                    {...register('course' , { required :  "*Please Input Your Data"})} 
                                    className='select'>
                                    {
                                        courseList.map( (item , index) => <option key={index} value={item.title}>{item.title}</option>)
                                    }
                                </select>
                                {errors.class && <span className='errors'>{errors.class.message}</span>}
                                </div>

                                <div className='input-wrapper'>

                                <input 
                                    {...register('phone' , { required :  "*Please Input Your Phone"})} 
                                    className='input' 
                                    placeholder='Phone Number*' 
                                />
                                {errors.phone && <span className='errors'>{errors.phone.message}</span>}
                                </div>

                                <div className='input-wrapper'>
                                <input
                                    {...register('institution' , { required : "*Please Input Your Company / Institution" , })}  
                                    className='input' 
                                    placeholder='Company / Institution*' 
                                />
                                {errors.company && <span className='errors'>{errors.company.message}</span>}
                                </div>
                                

                                <button className='submit' type='submit'>Submit</button>
                            </form> : null
                            }
                        </div>
                    </div> */}
                </div> : 
                <div className='notfound'>
                    <Grid className='wrapper' container>
                        <Grid lg={5} md={6} xs={12}>
                            <div className='logo-img'>
                                <img src={NotFound} alt='' />
                            </div>
                        </Grid>
                        <Grid lg={7} md={6} xs={12}>
                            <div className='information'>
                                <h3 className='title'>Oops! Page not found</h3>
                                <p className='body'>Please go back to the homepage</p>
                                <Link to='/' className='link-direction'>BACK TO HOMEPAGE</Link>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            }
        </section>
    )
}

export default Index
